import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { HiMagnifyingGlass, HiDocumentText, HiSparkles } from 'react-icons/hi2';
import { fetchAuthConfig } from '@/env';
import { Page, Nav, Brand, BrandLogo, Hero, HeroLogo, Title, Subtitle, LoginButton, SignupLink, Features, Feature, Footer } from './WelcomePage.styled';

export default function WelcomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [signupEnabled, setSignupEnabled] = useState(false);

  useEffect(() => {
    fetchAuthConfig()
      .then((config) => setSignupEnabled(config.signupEnabled))
      .catch(() => setSignupEnabled(false));
  }, []);

  return (
    <Page>
      <Nav>
        <Brand>
          <BrandLogo src="/logo_32_32.png" alt="Scribia" />
          Scribia
        </Brand>
      </Nav>
      <Hero>
        <HeroLogo src="/logo_350_350.png" alt="Scribia" />
        <Title>{t('welcome.title')}</Title>
        <Subtitle>{t('welcome.subtitle')}</Subtitle>
        <LoginButton onClick={() => navigate('/login')}>
          {t('welcome.loginButton')}
        </LoginButton>
        {signupEnabled && (
          <SignupLink onClick={() => navigate('/signup')}>
            {t('welcome.signupButton')}
          </SignupLink>
        )}
        <Features>
          <Feature>
            <HiMagnifyingGlass />
            <span>{t('welcome.featureSearch')}</span>
          </Feature>
          <Feature>
            <HiDocumentText />
            <span>{t('welcome.featureDocuments')}</span>
          </Feature>
          <Feature>
            <HiSparkles />
            <span>{t('welcome.featureAI')}</span>
          </Feature>
        </Features>
      </Hero>
      <Footer>Scribia</Footer>
    </Page>
  );
}
